import React, { Component } from 'react';
import { Switch } from 'react-router';
import { AuthenticatedRoute, UnauthenticatedRoute } from 'components/Route';

/**
 * Import pages and routes
 */

import Home from './Home/Home';
import Uitleg from './Uitleg/Uitleg';
import VoorbeeldLeerlijn from './VoorbeeldLeerlijn/VoorbeeldLeerlijn';
import Favorites from './Favorites/Favorites';
import Login from './Login/Login';
import WebsiteHome from './WebsiteHome/WebsiteHome'
import CmsPage from './CmsPage/CmsPage';
import Profile from './Profile/Profile';
import Register from './Register/Register';
import ForgotPassword from './ForgotPassword/ForgotPassword';
import ResetPassword from './ResetPassword/ResetPassword';

class Routes extends Component {
    render() {
        return (
            <Switch>
                <UnauthenticatedRoute exact path='/platform/:cardId?/:name?' component={Home} />
                <UnauthenticatedRoute exact path='/platform-filter/:filter' component={Home} />
                <UnauthenticatedRoute exact path='/uitleg' component={Uitleg} />
                <UnauthenticatedRoute exact path='/voorbeeldleerlijn/:cardId?/:name?' component={VoorbeeldLeerlijn} />
                <UnauthenticatedRoute exact path='/favorieten' component={Favorites} />
                <UnauthenticatedRoute exact path='/inloggen' component={Login} />
                <AuthenticatedRoute exact path='/profile' component={Profile} />
                <UnauthenticatedRoute exact path='/registreren' component={Register} />
                <UnauthenticatedRoute exact path='/wachtwoord-vergeten' component={ForgotPassword} />
                <UnauthenticatedRoute exact path='/wachtwoord-herstellen' component={ResetPassword} />
                <UnauthenticatedRoute exact path='/' component={WebsiteHome} />
                <UnauthenticatedRoute exact path='/homepage-preview/:versionId' component={WebsiteHome} />
                <UnauthenticatedRoute exact path='/:page' component={CmsPage} />
            </Switch>
        );
    }
}

export default Routes;